import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useHeader } from './hooks/useHeader';

export const Header: React.FC = () => {
	const { headline, description } = useHeader();

	return (
		<>
			<Box sx={{ mb: 8 }}>
				<Heading
					size="h3"
					as="h1"
					data-qa="ppmu-modal-header-title"
					sx={{
						color: 'sunrise.semantic.typography.strong',
						fontSize: 24,
						fontWeight: 700,
						lineHeight: '32px',
					}}
				>
					{headline}
				</Heading>
			</Box>
			<Text
				data-qa="ppmu-modal-header-description"
				sx={{
					color: 'sunrise.semantic.typography.weak',
					fontSize: 16,
					lineHeight: '24px',
					fontWeight: 400,
				}}
			>
				{description}
			</Text>
		</>
	);
};
